/* tslint:disable */
import {
  Group
} from '../index';

declare var Object: any;
export interface GroupRoleInterface {
  "groupId"?: number;
  "roleId"?: number;
  "createdAt": Date;
  "createdBy"?: number;
  "updatedAt": Date;
  "updatedBy"?: number;
  "id"?: number;
  group?: Group;
  role?: any;
}

export class GroupRole implements GroupRoleInterface {
  "groupId": number;
  "roleId": number;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  group: Group;
  role: any;
  constructor(data?: GroupRoleInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `GroupRole`.
   */
  public static getModelName() {
    return "GroupRole";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of GroupRole for dynamic purposes.
  **/
  public static factory(data: GroupRoleInterface): GroupRole{
    return new GroupRole(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'GroupRole',
      plural: 'GroupRoles',
      path: 'GroupRoles',
      idName: 'id',
      properties: {
        "groupId": {
          name: 'groupId',
          type: 'number'
        },
        "roleId": {
          name: 'roleId',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        group: {
          name: 'group',
          type: 'Group',
          model: 'Group',
          relationType: 'belongsTo',
                  keyFrom: 'groupId',
          keyTo: 'id'
        },
        role: {
          name: 'role',
          type: 'any',
          model: '',
          relationType: 'belongsTo',
                  keyFrom: 'roleId',
          keyTo: 'id'
        },
      }
    }
  }
}
